import { Link } from "react-router-dom";
import { History, RotateCcw, BookHeart, HeartHandshake, Utensils } from "lucide-react";
import { ProfilePicker } from "@/components/ProfilePicker";
import { AcornJar } from "@/components/AcornJar";

export const Brand = () => (
  <Link to="/" className="flex items-center gap-3" data-testid="brand-home-link">
    <img src="/acorn-t.png" alt="Colorful Acorn logo" className="pp-logo-img" data-testid="app-logo" />
    <div>
      <p className="pp-brand" data-testid="app-brand-name"><span className="rainbow">NICE</span><sup className="pp-tm">™</sup></p>
      <p className="pp-slogan" data-testid="app-brand-slogan">Developing Character Before Convenience</p>
      <p className="pp-tag" data-testid="app-brand-tagline">A Colorful Acorn Parenting™ Resource</p>
      <p className="pp-tag pp-service" data-testid="app-brand-service">a product of BurrHaus Counseling, LLC.</p>
    </div>
  </Link>
);

export const Header = ({ onHistory, onNew, profiles, profile, onPick, jar }) => (
  <header className="pp-header" data-testid="app-header">
    <Brand />
    <div className="flex items-center gap-2 flex-wrap">
      <AcornJar jar={jar} />
      <ProfilePicker profiles={profiles} profile={profile} onPick={onPick} />
      <span className="pp-badge" data-testid="age-badge">Kids 4–12</span>
      <Link to="/manners" className="pp-ghost pp-tips-link" data-testid="manners-link">
        <Utensils className="h-4 w-4" /> <span className="hidden sm:inline">Manners</span>
      </Link>
      <Link to="/sorry" className="pp-ghost pp-tips-link" data-testid="sorry-steps-link">
        <HeartHandshake className="h-4 w-4" /> <span className="hidden sm:inline">The 3 Steps of an Apology</span>
      </Link>
      <Link to="/parents" className="pp-ghost pp-tips-link" data-testid="parent-tips-link">
        <BookHeart className="h-4 w-4" /> <span className="hidden sm:inline">Parent tips</span>
      </Link>
      <button className="pp-icon" data-testid="new-request-button" onClick={onNew} aria-label="New request">
        <RotateCcw className="h-4 w-4" />
      </button>
      <button className="pp-icon" data-testid="history-drawer-trigger-button" onClick={onHistory} aria-label="History">
        <History className="h-4 w-4" />
      </button>
    </div>
  </header>
);
